import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockOn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.749 0.833008C12.0751 0.833008 13.3475 1.36017 14.2852 2.29785C15.2226 3.2355 15.749 4.50708 15.749 5.83301V8.33301H16.583C17.9636 8.33318 19.083 9.4524 19.083 10.833V16.666C19.083 18.0466 17.9636 19.1658 16.583 19.166H4.91602C3.5353 19.166 2.41602 18.0467 2.41602 16.666V10.833C2.41602 9.4523 3.5353 8.33301 4.91602 8.33301H5.74902V5.83301C5.74902 4.507 6.27629 3.23552 7.21387 2.29785C8.15147 1.36025 9.42306 0.833094 10.749 0.833008ZM4.91602 10C4.45578 10 4.08301 10.3728 4.08301 10.833V16.666C4.08301 17.1263 4.45578 17.5 4.91602 17.5H16.583C17.0431 17.4998 17.416 17.1261 17.416 16.666V10.833C17.416 10.3729 17.0431 10.0002 16.583 10H4.91602ZM10.749 2.5C9.86524 2.50009 9.01759 2.85074 8.39258 3.47559C7.76746 4.10071 7.41602 4.94895 7.41602 5.83301V8.33301H14.083V5.83301C14.083 4.94895 13.7316 4.10071 13.1064 3.47559C12.4813 2.85057 11.633 2.5 10.749 2.5Z",
		fill: "white"
	})
});
export default SvgLockOn;
